import ApiaField from '../ApiaField';
import Field from '../constants/Field';
import ApiaForm from '../ApiaForm';
import { IApiaField } from '../types';

export type TPasswordField = IApiaField;

export default class PasswordField extends ApiaField implements TPasswordField {
  constructor(field: HTMLInputElement, form: ApiaForm) {
    super(field, form, [
      Field.PROPERTY_REQUIRED,
      Field.PROPERTY_DISABLED,
      Field.PROPERTY_READONLY,
      Field.PROPERTY_SHOW_TOOLTIP_AS_HELP,
    ]);
  }
}
